export const Max80Div = (props) => (<div className="max-width-80">{props.children}</div>);
export const Max75Div = (props) => (<div className={`max-width-75 ${props.className || ""}`}>{props.children}</div>);
export const Max50Div = (props) => (<div className="max-width-50">{props.children}</div>);